import React from "react";
import "../../css/pages/PreviousComments.scss";
import { useGetCommentsByContentId } from "../../queries/comments/use-get-comments-by-content-id";
import { useParams } from "react-router-dom";

interface CommentData {
  id: number;
  name: string;
  commentBody: string;
  email: string;
  createdAt: string;
}

interface Props {
  category: string;
  contentId: number;
}
const PreviousComments: React.FC<Props> = ({ category, contentId }) => {
  const { data: comments } = useGetCommentsByContentId(category, contentId);
  return (
    <div className="previous-comments-container">
      <h3 className="previous-comments-title">دیدگاه‌های قبلی</h3>
      {comments?.length === 0 ? (
        <div className="no-comments">هنوز دیدگاهی ثبت نشده است.</div>
      ) : (
        comments?.map((comment: any) => (
          <div className="previous-comment-card" key={comment.id}>
            <div className="comment-header">
              <span className="comment-name">{comment.name}</span>
              {new Date(comment.createdAt).toLocaleDateString(
                "fa-IR-u-ca-persian"
              )}
            </div>
            <div className="comment-body">{comment.commentBody}</div>
          </div>
        ))
      )}
    </div>
  );
};

export default PreviousComments;
